package de.n4.careflex.common

import kotlin.js.Date

/*
 * The setters methods on JS-Date are missing in Kotlin.
 */
inline fun Date.setDate(date: Int): Unit { this.asDynamic().setDate(date) }
